import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CenteredSpinner } from '../components/Spinner.tsx';
import { ErrorMessage } from '../components/ErrorMessage.tsx';
import { getSupabase } from '../lib/supabase.ts';
import { setCompanyAccessToken } from '../lib/auth/companyToken.ts';

export function DriverCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<unknown>(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    let supabase;
    try {
      supabase = getSupabase();
    } catch (err) {
      setError(err);
      return;
    }

    void supabase.auth
      .getSession()
      .then(({ data }) => {
        if (data.session) {
          setCompanyAccessToken(data.session.access_token);
          window.history.replaceState({}, '', '/d');
          navigate('/d', { replace: true });
          return;
        }

        const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        const access = fragment.get('access_token');
        const refresh = fragment.get('refresh_token');
        if (!access || !refresh) {
          throw new Error('No session in callback URL');
        }
        return supabase.auth
          .setSession({ access_token: access, refresh_token: refresh })
          .then(({ error: setErr }) => {
            if (setErr) throw setErr;
            setCompanyAccessToken(access);
            window.history.replaceState({}, '', '/d');
            navigate('/d', { replace: true });
          });
      })
      .catch((err) => setError(err));
  }, [navigate]);

  if (error) {
    return (
      <div className="mx-auto mt-24 max-w-md px-4">
        <ErrorMessage error={error} />
      </div>
    );
  }
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50">
      <CenteredSpinner />
      <p className="text-sm text-slate-500">Signing you in…</p>
    </div>
  );
}
